export default function ToolbarNavigationMenuIds() {
    return {
        RootDocumentsTab :'toolbar-documents-tab',
        RootProductsTab :'toolbar-products-tab',
        RootContractorsTab :'toolbar-contractors-tab',
        RootCostsTab :'toolbar-costs-tab',

        DocumentsAddInvoiceSubTab: 'toolbar-documents-add-invoice-button',
        DocumentsAddInvoiceSubTabDropdownButton: 'toolbar-documents-add-invoice-dropdown-button',
        DocumentsListInvoicesSubTab: 'toolbar-documents-list-invoices-button',
        DocumentsListInvoicesAutomaticSubTab: 'toolbar-documents-list-invoices-automatic',
        DocumentsAddProformaSubTab: 'toolbar-documents-add-proforma-button',
        DocumentsAddProformaSubTabDropdownButton: 'toolbar-documents-add-proforma-dropdown-button',

        CostsAddInvoiceSubTab: 'toolbar-costs-add-invoice-button',
        CostsAddInvoiceSubTabDropdownButton: 'toolbar-costs-add-invoice-dropdown-button',
        CostsListInvoicesSubTab: 'toolbar-costs-list-invoices-button',
        CostsListInvoicesAutomaticSubTab: 'toolbar-costs-list-invoices-automatic',

        ProductsAddProductSubTab: 'toolbar-products-add-product-button',
        ProductsListProductsSubTab: 'toolbar-products-list-products-button',

        ContractorsAddContractorSubTab: 'toolbar-contractors-add-contractor-button',
        ContractorsListContractorsSubTab: 'toolbar-contractors-list-contractors-button',
      };
}